import { render, staticRenderFns } from "./ProductCat.vue?vue&type=template&id=a5fed238&"
import script from "./ProductCat.vue?vue&type=script&lang=js&"
export * from "./ProductCat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports